import type { Folha, Secao } from './conteudo'

/** Onde a folha vai ser desenhada. */
export type Destino = 'app' | 'pagina'

// A folha e uma so; o que muda entre os dois lugares e UM bloco. Escrito como
// filtro, e nao como duas listas: duas listas divergem no dia em que alguem
// acrescenta secao numa e esquece a outra.
//
// ⚠ Filtra BLOCO, nunca secao -- decisao dela em 14/08 foi "tudo, igual a
// pagina web", e o primeiro desenho escondia a secao "Instalar no celular"
// inteira para esconder um aviso de tres linhas. Ha teste cobrando.
export function secoesPara(folha: Folha, destino: Destino): Secao[] {
  if (destino === 'pagina') return folha.secoes
  return folha.secoes.map((secao) => ({
    ...secao,
    blocos: secao.blocos.filter((bloco) => bloco.apenasNaPagina !== true),
  }))
}
